// extracted by mini-css-extract-plugin
module.exports = {"loaderCard":"loader_loaderCard__uXocP"};